import { createContext, useCallback, useContext, useState } from "react";
import RegisterModal from "@/components/home/RegisterModal";

const Ctx = createContext({ openModal: () => {} });

export const useRegisterModal = () => useContext(Ctx);

// openModal("Evento") | openModal({ event, plan, source })
export const RegisterModalProvider = ({ children }) => {
  const [state, setState] = useState({ open: false, event: "", plan: "", source: "" });
  const openModal = useCallback((opts = {}) => {
    const o = typeof opts === "string" ? { event: opts } : opts;
    setState({ open: true, event: o.event || "", plan: o.plan || "", source: o.source || "" });
  }, []);
  const close = useCallback(() => setState((s) => ({ ...s, open: false })), []);

  return (
    <Ctx.Provider value={{ openModal }}>
      {children}
      <RegisterModal open={state.open} event={state.event} plan={state.plan} source={state.source} onClose={close} />
    </Ctx.Provider>
  );
};

export default RegisterModalProvider;
